// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import TrademarkCircleOutlinedSvg from "@fishx/icons-svg/es/asn/TrademarkCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var TrademarkCircleOutlined = function TrademarkCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: TrademarkCircleOutlinedSvg
  }));
};

TrademarkCircleOutlined.displayName = 'TrademarkCircleOutlined';
export default React.forwardRef(TrademarkCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/TrademarkCircleOutlined.js
// module id = 4278
// module chunks = 0